import { Button, Container, FormControl, FormLabel, InputLabel, MenuItem, Select } from '@material-ui/core'
import React from 'react'
import DatePicker from 'react-datepicker'
import { setData } from '../reducers/dataReducer'
import { setStart } from '../reducers/StartDateReducer'
import { setEnd } from '../reducers/EndDateReducer'
import { connect } from 'react-redux'
import graphService from '../services/graphService'
// Reduxilla hallitaan data ja päivämäärien tilamuuttujia
const DateChooser = (props) => {
  const handleClear = () => {
    props.setStart(new Date())
    props.setEnd(new Date())
    props.setData('')
  }

  const handleChange = (event) => {
    props.setSensor(event.target.value)
  }

  return (
    <Container>
      <div className="calendar">
        <form onSubmit={props.handleSubmit}>
          <FormControl fullWidth style={{ color:'black', background:'white' }}>
            <InputLabel variant="filled" style={{ color: 'black' }} htmlFor="uncontrolled-native">
              Choose Sensor
            </InputLabel>
            <Select
              required
              value={props.sensor}
              onChange={handleChange}
            >
              {
                graphService.sensors.map(s =>
                  <MenuItem key={s.id} value={s}>{s.name}</MenuItem>
                )
              }
            </Select>
          </FormControl>
          <table>
            <tbody>
              <tr>
                <td>
                  <FormLabel style={{ color: 'white' }}>Starting date:</FormLabel>
                </td>
                <td>
                  <DatePicker
                    autoComplete="off"
                    selected={props.start}
                    name="Start"
                    value={props.start}
                    onChange={date => props.setStart(date)}
                    dateFormat="dd.MM.yyyy" />
                </td>
              </tr>
              <tr>
                <td>
                  <FormLabel style={{ color: 'white' }}>Ending date:</FormLabel>
                </td>
                <td>
                  <DatePicker autoComplete="off" selected={props.end} name="End" value={props.end} onChange={date => props.setEnd(date)}  dateFormat="dd.MM.yyyy" />
                </td>
              </tr>
            </tbody>
          </table>
          <Button style={{ background:'black', color:'white' }} type="submit">Search</Button>
          <Button style={{ background:'black', color:'white' }} onClick={handleClear}>Clear</Button>
        </form>
      </div>
    </Container>
  )
}

const mapStateToProps = (state) => {
  return {
    start: state.start,
    end: state.end
  }
}

const mapDispatchToProps = {
  setStart,
  setEnd,
  setData
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DateChooser)